export enum SequenceMode {
    Default,
    Playback,
    Timeline,
}

export default SequenceMode;
